// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"OrderErrorView_errorContainer__slUbV"};